'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _server = require('react-dom/server');

var _reactTweetEmbed = require('react-tweet-embed');

var _reactTweetEmbed2 = _interopRequireDefault(_reactTweetEmbed);

var _YoutubeVideo = require('./YoutubeVideo');

var _YoutubeVideo2 = _interopRequireDefault(_YoutubeVideo);

var _Video = require('./Video');

var _Video2 = _interopRequireDefault(_Video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Element = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Element, _Component);

  function Element(props) {
    (0, _classCallCheck3.default)(this, Element);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Element.__proto__ || (0, _getPrototypeOf2.default)(Element)).call(this, props));

    _this.getComponentFromType = function (type, src, srcSubtitles, subtitleOn, srcPoster, subtitle, style) {
      var DumbComponent = function DumbComponent(_ref) {
        var children = _ref.children;
        return _react2.default.createElement(
          'div',
          null,
          children
        );
      };

      var element = function (type) {
        switch (type) {
          case 'video':
            return _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_Video2.default, { sources: [this.context.baseUrl + '/' + src], subtitles: [{ src: this.context.baseUrl + "/" + srcSubtitles, label: "Spanish", lang: "es" }], autoPlay: true, activeSubtitle: 0, subtitleOn: subtitleOn, isSubtitled: true, width: '100%', height: '100%' }),
              _react2.default.createElement(
                'p',
                null,
                subtitle
              )
            );
          case 'image':
            return _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('img', { src: this.context.baseUrl + '/' + src, alt: subtitle }),
              _react2.default.createElement(
                'p',
                null,
                subtitle
              )
            );
          case 'twitter':
            return _react2.default.createElement(_reactTweetEmbed2.default, { id: src });
          case 'youtube':
            return _react2.default.createElement(YouTubeVideo, { id: src });
          case 'iframe':
            return _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('iframe', { src: src, frameBorder: '0', scrolling: 'no' }),
              _react2.default.createElement(
                'p',
                null,
                subtitle
              )
            );
          default:
            return _react2.default.createElement(
              'div',
              null,
              'Comprueba tu conexi\xF3n'
            );
        }
      }.bind(_this)(type);
      return element;
      //return ((type === "twitter") || (type === "youtube") || (type === "video")) ? element : <DumbComponent>{element}</DumbComponent>;
    };

    return _this;
  }

  (0, _createClass3.default)(Element, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          mediaId = _props.mediaId;

      var mediaElement = this.getComponentFromType(data.type, data.src, data.srcSubtitles, data.subtitleOn, data.srcPoster, data.subtitle, data.style);

      /*let renderThis;
      if ((data.type === "twitter") || (data.type === "youtube") || (data.type === "video")) {
        renderThis = mediaElement;
      } else {
        const html = renderToString(mediaElement);
        renderThis = <div dangerouslySetInnerHTML={{__html: html}}></div>
      }*/

      return _react2.default.createElement(
        'div',
        { className: 'element', 'data-media-id': mediaId },
        mediaElement
      );
    }
  }]);
  return Element;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.shape({
    type: _react.PropTypes.string,
    src: _react.PropTypes.string,
    srcSubtitles: _react.PropTypes.string,
    subtitleOn: _react.PropTypes.bool,
    srcPoster: _react.PropTypes.string,
    subtitle: _react.PropTypes.string,
    mediaId: _react.PropTypes.number
  }),
  mediaId: _react.PropTypes.number
}, _class.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired
}, _temp);
exports.default = Element;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/Element.js
// module id = 227
// module chunks = 0